import React from 'react';

export default function HotelMainInfoItem({header, data}) {
  return data ? (
    <li className="hotel__info-item">
      <h5 className="hotel__info-item-header">{header}</h5>
      <p className="hotel__info-item-text">{data}</p>
    </li>
  ) : null;
}
